import React from "react";
import { useLoader } from "../hooks/LoaderContext";
import { CircleLoader } from "react-spinners";

const Loader = () => {
    const { loading } = useLoader();

    if (!loading) return null;

    return (
        <div style={{
            position: "fixed",
            top: 0, left: 0, width: "100%", height: "100%",
            background: "rgba(0, 0, 0, 0.8)",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            zIndex: 1000
        }}>
            <CircleLoader height="100"
                width="100"
                color="#30776b" />
        </div>
    );
};

export default Loader;